// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { LinkPagesRepoService } from '@client/app/services/api/link-pages-repo/link-pages-repo.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { MonTableCollection } from '@client/ng2/models/table-collection.interface';
import { Page } from '@monsido/modules/page-details/models';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-email',
    template: `
        <div class="mon-dialog-header">
            <page-header header="{{'Pages that contain the Email' | translate}}" subHeader="{{ email.url }}">
            <page-header-content>
                <div class="row mon-dialog-delay-fadein">
                    <div class="col-48 inner-r-large outer-t-mini">
                        <table-search [minSearchLength]="3"
                                      class="inline-block outer-r-small pull-right"
                                      theme="grey-theme"
                                      placeholderTxt="{{'Search...' | translate}}"
                                      [model]="search"
                                      (getPage)="onSearch($event)">
                        </table-search>
                    </div>
                </div>
            </page-header-content>
    </page-header>
        </div>
        <div class="mon-dialog-body">
            <div class="card panel-monsido-card outer-t outer-r outer-l">
                <div class="card-body">
                        <table-container [collection]="pages"
                                 (onPageChange)="onPageChange($event)"
                                 (onPerPageChange)="onPageSizeChange($event)"
                                 [progress]="promise"
                                 class="pages-table-wrapper">
                            <table class="table table-hover table-fixed">
                                <thead>
                                <tr>
                                    <th class="col-sm-16 col-md-16" translate>Title and URL</th>
                                    <th class="col-sm-8 col-md-4"
                                        monTableSort
                                        [monSortDirection]="currentSort.direction"
                                        monSortBy="hits"
                                        [monCurrentlySortedBy]="currentSort.by"
                                        (monOnSorted)="onMonTableSort($event)"
                                        *ngIf="viewsColumIsAvailable">{{'Views' | translate}}</th>
                                    <th class="col-sm-8 col-md-4">&nbsp;</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let page of pages">
                                    <td class="text-ellipsis">
                                        <mon-url-title
                                                *ngIf="!pageDetailsIsAvailable"
                                                [title]="page.title"
                                                [url]="page.url"
                                                [active]="false">
                                        </mon-url-title>
                                        <url-title-page-details
                                                *ngIf="pageDetailsIsAvailable && page.type === 'html'"
                                                [target]="'page-details-section-inventory'"
                                                [subTarget]="'emails'"
                                                [page]="page"
                                                [title]="page.title"
                                                [url]="page.url"
                                                [active]="false" ></url-title-page-details>
                                        <url-title-document-details *ngIf="pageDetailsIsAvailable && page.type !== 'html'"
                                                                    [document]="page"
                                                                    [title]="page.title"
                                                                    [url]="page.url"
                                                                    [active]="true"
                                                                    [target]="'inventory'"
                                                                    [subTarget]="'emails'">
                                        </url-title-document-details>
                                    </td>
                                    <td *ngIf="viewsColumIsAvailable" class="text-v-middle">
                                        <visits visits="{{page.hits}}"  title="{{page.title}}" totalVisits="{{pages.pageHits}}"></visits>
                                    </td>
                                    <td class="text-right text-v-middle" [attr.aria-label]="'Page details' | translate">
                                        <table-page-details
                                                *ngIf="page.type === 'html'"
                                                [ngbTooltip]="'Open page details' | translate"
                                                [triggers]="'focus hover'"
                                                [target]="'page-details-section-inventory'"
                                                [subTarget]="'emails'"
                                                class="list-inline inline-block"
                                                [page]="page">
                                        </table-page-details>
                                        <table-document-details
                                                *ngIf="page.type !== 'html'"
                                                ngbTooltip="{{'Open document details' | translate}}"
                                                [triggers]="'focus hover'"
                                                target="inventory"
                                                [subTarget]="'emails'"
                                                class="list-inline inline-block"
                                                [document]="page"
                                                (callBack)="onPageDetailsClose()">
                                        </table-document-details>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                </table-container>
                </div>
            </div>
        </div>
    `,
    standalone: false,
})
export class PagesEmailComponent extends BaseContainerComponentController implements OnInit {
    @Input() email: any;
    @Input() type: string = '';

    viewsColumIsAvailable: boolean = false;
    pageDetailsIsAvailable: boolean = false;
    pages: MonTableCollection<Page> = [] as any;
    override search: string = '';
    override page: number = 1;
    override pageSize: number = 20;
    override currentSort: any = { by: 'hits', direction: 'desc' };
    promise: Promise<any> | null = null;

    constructor (
        private linkPagesRepoService: LinkPagesRepoService,
        private activeFeatureService: ActiveFeatureService,
    ) {
        super({ table: true });
        this.currentSort.by = 'hits';
        this.currentSort.direction = 'desc';
    }

    ngOnInit (): void {
        this.init();
    }

    private init (): void {
        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.pages = [] as any;
        this.pages.total = 0;
        this.search = '';
        this.currentSort = { by: 'hits', direction: 'desc' };
        this.getPage();
    }

    override getPage = (): void => {
        if (!this.email?.id) {
            return;
        }

        const params: any = {
            link_id: this.email.id,
            page: this.page,
            page_size: this.pageSize,
            search: this.search ?? '',
            'types[]': 'html',
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        if (this.type === 'document') {
            params['types[]'] = ['document', 'pdf'];
        }

        this.promise = this.linkPagesRepoService.get(params).then((data) => {
            this.pages = data;
        }).catch(() => {
            // Handle error silently like angular.noop
        });
    };
}
